export default class PlatformEngineeringConstants {
  static readonly ReasonAlert = 'Reason should be given...!';
  static readonly RestartQueued = 'runbook queued for Restarting Tenant...!';
}
